import React from 'react'
import RenderAutoNameSuggest from './renderAutoNameSuggest.component'
import { Translation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  select: {
    marginTop: theme.spacing(3),
    minWidth: 300,
    lineHeight: '1.5',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif',
    textAlign: 'center'
  },
  textArea: {
    marginTop: theme.spacing(3),
    minWidth: 300,
    lineHeight: '1.5',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray',
    fontFamily: 'Poppins, sans-serif',
    textAlign: 'center'
  },
  button: {
    width: '80%',
    marginTop: theme.spacing(4)
  }
})

const UserSelectorComp = ({
  classes,
  selectedIndex,
  selectedEmail,
  usersList
}) => {
  const [disabled, setDisabled] = React.useState(false)
  const [value, setValue] = React.useState(
    selectedIndex > -1 ? selectedIndex : null
  )

  return (
    <Translation>
      {(t) => {
        return (
          <div style={{ marginBottom: '80px' }}>
            <div
              className={'col-xs-12 col-sm-9 col-lg-9'}
              style={{ width: '350px' }}
            >
              <label>{t('asiakkaat.customer')}</label>
              <RenderAutoNameSuggest
                name="email"
                options={usersList}
                className={classes.textArea}
                disabled={disabled}
                setDisabled={setDisabled}
                value={value}
                setValue={setValue}
                selectedEmail={selectedEmail}
              />
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(UserSelectorComp)
